import { z } from 'zod';

import { SectionDtoScheme } from '~modules/section/model';

export const DepartmentDtoSchema = z.object({
	department_id: z.string().describe('Идентификтор подразделения'),
	organization_id: z.string().describe('Идентификтор юр. лица'),
	department_name: z.string().describe('Наименование подразделения'),
	organization_name: z.string().describe('Наименование организации'),
});

export type DepartmentDto = z.infer<typeof DepartmentDtoSchema>;

export const SectionWithDepartmentDtoScheme = SectionDtoScheme.extend({
	departments: z.array(DepartmentDtoSchema).describe('Подразделения привязанные к участку'),
});

export type SectionWithDepartmentDto = z.infer<typeof SectionWithDepartmentDtoScheme>;
